import { addTrainingVideo,addQuestionnaireDetail,getQuestionnaire,
    addQuestionnaire,getQueDetailList,delQuestionnaireDetail,
    updateQuestionnaireDetail,getTrainingVideo,delTrainingVideo,
    updateQuestionnaireSwitch,updateQuestionnaire } from '@/api/wenjuan'
import { getToken, setToken, setCache, getCache } from '@/utils/auth'
import { Message } from 'element-ui'
import i18n from '@/lang'
import 'babel-polyfill'
import promise from 'es6-promise'
promise.polyfill()
const user = {
    state: {},
    mutations: {},
    actions: {
        getTrainingVideo({ commit }, info) {
            return new Promise((resolve, reject) => {
                getTrainingVideo(info).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        delTrainingVideo({ commit }, info) {
            return new Promise((resolve, reject) => {
                delTrainingVideo(info).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        addTrainingVideo({ commit }, info) {
            return new Promise((resolve, reject) => {
                addTrainingVideo(info).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        addQuestionnaireDetail({ commit }, info) {
            return new Promise((resolve, reject) => {
                addQuestionnaireDetail(info).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getQueDetailList({ commit }, info) {
            return new Promise((resolve, reject) => {
                getQueDetailList(info).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getQuestionnaire({ commit }, info) {
            return new Promise((resolve, reject) => {
                getQuestionnaire(info).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        addQuestionnaire({ commit }, info) {
            return new Promise((resolve, reject) => {
                addQuestionnaire(info).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        updateQuestionnaire({ commit }, info) {
            return new Promise((resolve, reject) => {
                updateQuestionnaire(info).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        delQuestionnaireDetail({ commit }, info) {
            return new Promise((resolve, reject) => {
                delQuestionnaireDetail(info).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        updateQuestionnaireDetail({ commit }, info) {
            return new Promise((resolve, reject) => {
                updateQuestionnaireDetail(info).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        updateQuestionnaireSwitch({ commit }, info) {
            return new Promise((resolve, reject) => {
                updateQuestionnaireSwitch(info).then(response => {
                    let { status } = response
                    if (status === 0) {
                        setCache('questionnaireSwitch',info.questionnaireSwitch)
                    }
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        }
    }
}
export default user


// WEBPACK FOOTER //
// ./src/store/modules/wenjuan.js